import type {IssueCreateStatus} from '../hooks/use-issue-form-secondary-query'

// Matched by category rather than name so a renamed status still becomes the default.
const DEFAULT_STATUS_CATEGORY = 'Backlog'

/**
 * The status a new issue gets: the viewer's pick when this owner offers it, otherwise the owner's first backlog
 * status. A pick can go stale when the viewer switches to a repository with another owner.
 */
export function resolveIssueStatus(
  openStatuses: readonly IssueCreateStatus[],
  picked: IssueCreateStatus | null,
): IssueCreateStatus | null {
  return (
    openStatuses.find(status => status.id === picked?.id) ??
    openStatuses.find(status => status.category.name === DEFAULT_STATUS_CATEGORY) ??
    null
  )
}
